
<div class="side-bar__ctn">
    <div class="left-navigation-menu" [class.close]="!isExpanded">
        <ng-container *ngIf="isLoggedIn">
            <ng-container *ngIf="(this.toggleFeatureSelect$ | async) as toggleFeatureView">
                <ng-container *ngFor="let route of routes">
                    <ng-container
                        *ngIf="route.id !== routeId.DASHBOARD || (route.id === routeId.DASHBOARD  && toggleFeatureView.displayNonImplementedMenus)">
                        <app-navigation-item [route]="route" [isExpanded]="isExpanded" [toggleFeatureView]="toggleFeatureView" [isLoggedIn]="isLoggedIn"></app-navigation-item>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>

    <!-- Static menus -->

        <div class="left-navigation-second static-menus" [ngClass]="{'expanded': isExpanded}">
            <ul>
                <ng-container *ngIf="(this.toggleFeatureSelect$ | async)?.displayNonImplementedMenus">
                    <li [pTooltip]="!isExpanded ? (adminRoute.name| translate ): ''">
                        <a class="layout-menu-button" [routerLink]="'/' + adminRoute.route" [queryParams]="adminRoute.params"
                            [routerLinkActive]="['active']">
                            <i [class]="adminRoute.icon"></i>
                            <span *ngIf="isExpanded" class="text-menu">{{adminRoute.name| translate}}</span>
                        </a>
                    </li>
                </ng-container>

                <li [pTooltip]="!isExpanded ? ('menu.quickAccess.label' | translate) : ''" (click)="quickAccess.toggle($event)">
                    <a class="layout-menu-button">
                        <i class="fas fa-grip"></i>
                        <ng-container *ngIf="isExpanded">
                            <span class="text-menu" [translate]="'menu.quickAccess.label'"></span>
                        </ng-container>
                    </a>
                </li>
            </ul>
        </div>

    <app-quick-access-panel #quickAccess></app-quick-access-panel>

     <div (click)="menuToggleChange.emit()" class="left-navigation-second" [ngClass]="{'expanded': isExpanded}" [pTooltip]="!isExpanded ? ('action.close' | translate) : ''">
        <ul>
            <li>
                <a class="layout-menu-button" [ngClass]="{'layout-menu-button-rotate': !isExpanded}">
                    <i class="pi pi-chevron-left"></i>
                    <ng-container *ngIf="isExpanded">
                        <span [@fadeInOut]="isExpanded ? 'visible' : 'hidden'" class="text-menu">{{'action.close' | translate}}</span>
                    </ng-container>
                </a>
            </li>
        </ul>
    </div>

</div>
